<template>
  <v-container>
    <v-row align="center" style="min-height:50vh">
      <v-col>
        <v-row>
          <v-col cols="12" class="text-center">
            <h3 v-html="title"></h3>
            <p>{{ text }}</p>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12"
            :md="size"
            v-for="(item, index) in list"
            :key="index"
            data-aos="zoom-in"
            :data-aos-delay="
              $vuetify.breakpoint.mdAndUp ? 300 * (index % stop) : 0
            "
          >
            <v-hover v-slot:default="{ hover }">
              <v-card :elevation="hover ? 1 : 0" class="pa-5">
                <v-img
                  class="mb-5"
                  contain
                  height="100"
                  :src="require(`@/assets/${item.img}`)"
                ></v-img>
                <h3 class="text-center" :style="`color:${color}`">
                  {{ item.title }}
                </h3>
                <p class="text-center">{{ item.text }}</p>
              </v-card>
            </v-hover>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  props: {
    title: String,
    text: String,
    list: Array,
    color: String
  },
  data: () => ({
    size: 4,
    stop: 3
  }),
  mounted() {
    this.size = this.list.length % 2 == 0 ? 3 : 4;
    this.stop = this.list.length % 2 == 0 ? 4 : 3;
  }
};
</script>
